import { Outlet, NavLink } from "react-router";

export const ProfileLayout = () => {
  return (
    <div className="flex flex-col min-h-screen">
      <header className="sticky top-0 bg-black border-b shadow-sm z-10">
        <div className="px-4 sm:px-24 py-4 flex justify-between items-center">
          <div className="flex items-center gap-4">
            <NavLink to="/dashboard" className="text-white hover:text-gray-200">
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M10 19l-7-7m0 0l7-7m-7 7h18"
                />
              </svg>
            </NavLink>
            <h1 className="text-xl font-semibold text-white">Dashboard</h1>
          </div>
        </div>
      </header>
      <div className="flex-1 flex gap-8 px-4 sm:px-24 py-8">
        {/* <aside
          className={`${
            isMobileMenuOpen ? "fixed inset-0 bg-white z-20" : "hidden"
          } md:relative md:block md:w-48 md:shrink-0`}
        >
          <div className="md:hidden flex items-center justify-between p-4 border-b bg-black">
            <h2 className="text-lg font-semibold text-white">TooEZ</h2>
            <button
              onClick={() => setIsMobileMenuOpen(false)}
              className="p-2 hover:bg-gray-100 rounded text-white"
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>
          <nav className="flex flex-col gap-2 p-4">
            <NavLink
              to="/account"
              className={({ isActive }) =>
                `p-2 rounded hover:bg-gray-100 ${isActive ? "bg-gray-100 font-medium" : ""}`
              }
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Account
            </NavLink>
            <NavLink
              to="/billing"
              className={({ isActive }) =>
                `p-2 rounded hover:bg-gray-100 ${isActive ? "bg-gray-100 font-medium" : ""}`
              }
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Billing
            </NavLink>
            <NavLink
              to="/business-account"
              className={({ isActive }) =>
                `p-2 rounded hover:bg-gray-100 ${isActive ? "bg-gray-100 font-medium" : ""}`
              }
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Business
            </NavLink>
            <NavLink
              to="/payment-methods"
              className={({ isActive }) =>
                `p-2 rounded hover:bg-gray-100 ${isActive ? "bg-gray-100 font-medium" : ""}`
              }
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Payment Methods
            </NavLink>
          </nav>
        </aside> */}
        <main className="flex-1">
          <Outlet />
        </main>
      </div>
    </div>
  );
};
